// extracted by mini-css-extract-plugin
export var quote = "blog-module--quote--j_0ha";
export var list = "blog-module--list--29W0B";